import React from 'react'
import './create-event.css'
import { baseUrl } from '../../assets/Animations'
import axios from 'axios'

const CreateEvent = (props) => {
    const [extraConnections, setExtraConnections] = React.useState([])
    const [familyNameSuggestions, setFamilyNameSuggestions] = React.useState([])
    const [teacherNameSuggestions, setTeacherNameSuggestions] = React.useState([])

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    const closeAttempt = (target) => {
        if(target === 'create-note-wrapper') {
            props.setCreateNote(false)
        }
    }

    React.useEffect(() => {
        console.log(props.createNote)
    }, [props.createNote])

    const setImportant = () => {
        props.setCreateNote({...props.createNote, important: !props.createNote.important})
    }

    const searchDatabaseForFamilyName = (id, index, value) => {
        
        let edittedConnections = props.createNote.connections
        for(let i = 0; i < edittedConnections.length; i++) {
            if(edittedConnections[i].connectionId === id) {
                edittedConnections[i].id = 'none'
                edittedConnections[i].displayName = value
            }
        }
        props.setCreateNote({...props.createNote, connections: edittedConnections})

        axios.get(`${baseUrl}/search/${value}`, myHeader)
        .then(res => {
            setFamilyNameSuggestions(res.data)
        })
        .catch(err => {
            console.log(err)
        })
    }

    const searchDatabaseForTeacher = (id, index, value) => {
        
        let edittedConnections = props.createNote.connections
        for(let i = 0; i < edittedConnections.length; i++) {
            if(edittedConnections[i].connectionId === id) {
                edittedConnections[i].id = 'none'
                edittedConnections[i].displayName = value
            }
        }
        props.setCreateNote({...props.createNote, connections: edittedConnections})

        axios.get(`${baseUrl}/teacher-search/${value}`, myHeader)
        .then(res => {
            setTeacherNameSuggestions(res.data)
        })
        .catch(err => {
            console.log(err)
        })
    }

    const addConnection = () => {
        let oldNote = props.createNote
        oldNote.connections.push({
            connectionId: Math.random().toString(16).slice(2), 
            type: 'none', 
            id: 'none', 
            displayName: ''
        })
        props.setCreateNote({...oldNote})
        // props.setCreateNote({...props.createNote, connections: props.createNote.connections.push({
        //     connectionId: Math.random().toString(16).slice(2), 
        //     type: 'none', 
        //     id: 'none', 
        //     displayName: ''
        // })})
        // setExtraConnections((oldArray) => [...oldArray, {
        //         connectionId: Math.random().toString(16).slice(2), 
        //         type: 'none', 
        //         id: 'none', 
        //         displayName: ''
        //     }
        // ])
    }

    const editConnection = (id, value) => {
        let edittedConnections = props.createNote.connections
        for(let i = 0; i < edittedConnections.length; i++) {
            if(edittedConnections[i].connectionId === id) {
                edittedConnections[i].type = value
                edittedConnections[i].id = 'none'
                edittedConnections[i].displayName = ''
            }
        }
        props.setCreateNote({...props.createNote, connections: edittedConnections})
        //setExtraConnections([...edittedConnections])
    }

    const chooseTheFamily = (id, sugg) => {
        //console.log(sugg)
        let edittedConnections = props.createNote.connections
        for(let i = 0; i < edittedConnections.length; i++) {
            if(edittedConnections[i].connectionId === id) {
                edittedConnections[i].id = sugg.familyId
                edittedConnections[i].displayName = sugg.familyName
            }
        }
        props.setCreateNote({...props.createNote, connections: edittedConnections})
        //setExtraConnections([...edittedConnections])
        props.editNotesConnections('familyId', sugg.familyId)
        setFamilyNameSuggestions([])

    }

    const chooseTheTeacher = (id, sugg) => {
        console.log(sugg)
        let edittedConnections = props.createNote.connections
        for(let i = 0; i < edittedConnections.length; i++) {
            if(edittedConnections[i].connectionId === id) {
                edittedConnections[i].id = sugg.TeacherID
                edittedConnections[i].displayName = sugg.Name
            }
        }
        props.editNotesConnections('teacherId', sugg.TeacherID)
        props.setCreateNote({...props.createNote, connections: edittedConnections})
        //setExtraConnections([...edittedConnections])
        setTeacherNameSuggestions([])
    }

    const removeConnection = (type, connectionId) => {
        let myNote = props.createNote
        let result = props.createNote.connections.filter(conn => conn.connectionId !== connectionId)
        myNote.connections = result
        console.log(result)
        props.setCreateNote({...myNote})
        //setExtraConnections(extraConnections.filter(conn => conn.connectionId !== connectionId))
        props.editNotesConnections(type, '')
    }

    const writeNote = (text) => {
        props.setCreateNote({...props.createNote, details: text})
    }

    return(
        <div className='create-note-wrapper' id='create-note-wrapper' onClick={(e) => closeAttempt(e.target.id)}>
            <div className='create-note-modal'>
                <div className='create-note-modal__title'>{props.createNote.displayName} Event</div>
                <div className='create-note-modal__toggle-switch' onClick={() => setImportant()}>
                    <div className='create-note-modal__important-label' style={props.createNote.important ? {color: 'red'} : {color: 'grey'}}>Important</div>
                    {!props.createNote.important && <svg className="switch-svg" viewBox="0 0 511.999 511.999">
                        <g>
                        	<g>
                        		<path fill="#8EAAAF" d="M376.499,120.5h-241C60.784,120.5,0,181.286,0,256s60.784,135.5,135.499,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                        			S451.214,120.5,376.499,120.5z M135.499,361.501C77.326,361.501,30,314.173,30,256c0-58.173,47.326-105.5,105.499-105.5
                        			c58.173,0,105.5,47.327,105.5,105.5C240.999,314.173,193.672,361.501,135.499,361.501z"/>
                        	</g>
                        </g>
                    </svg>}
                    {props.createNote.important && <svg className="switch-svg" viewBox="0 0 512 512">
                        <g>
                        	<g>
                        		<path fill="red" d="M376.5,120.5h-241C60.785,120.5,0,181.285,0,256s60.785,135.5,135.5,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                        			S451.215,120.5,376.5,120.5z M376.5,361.5C318.327,361.5,271,314.174,271,256c0-58.172,47.327-105.5,105.5-105.5
                        			c58.173,0,105.5,47.328,105.5,105.5C482,314.174,434.673,361.5,376.5,361.5z"/>
                        	</g>
                        </g>
                    </svg>}
                </div>
                <div className='create-note-modal__add-connection' onClick={() => addConnection()}>+ Add Connection</div>
                {props.createNote.connections.map((connection) => 
                    <div className='create-note-modal__connection-wrapper'>
                        <div className='create-note-modal__remove-connection-x' onClick={() => removeConnection(connection.type, connection.connectionId)}>x</div>
                        <select className='create-note-modal__drop-down-menu' value={connection.type} onChange={(e) => editConnection(connection.connectionId, e.target.value)}>
                            <option value="none">Select Connection</option>
                            {props.createNote.type !== 'teacherId' && <option value='teacherId'>Teacher</option>}
                            {props.createNote.type !== 'familyId' && <option value='familyId'>Family</option>}
                        </select>
                        {
                            connection.type === 'familyId' &&
                                <div className='create-note-modal__search-bar-wrapper'>
                                    <div className="create-note-modal__search-bar">
                                        <input className="manually-enter-family-name-input" placeholder="Search Family" value={connection.displayName} onChange={(e) => searchDatabaseForFamilyName(connection.connectionId, props.index, e.target.value)} />
                                    </div>
                                    {familyNameSuggestions.length > 0 &&
                                        <div className="create-note-modal__search-bar-suggestions-wrapper">
                                            {familyNameSuggestions.map((sugg) => (
                                                <h5 className="create-note-modal__search-bar-suggestions" key={sugg._id} onClick={() => chooseTheFamily(connection.connectionId, sugg)}>{sugg.primaryParentName} {sugg.familyName}</h5>
                                            ))}
                                        </div>
                                    }
                                </div>
                        }
                        {
                            connection.type === 'teacherId' &&
                                <div className='create-note-modal__search-bar-wrapper'>
                                    <div className="create-note-modal__search-bar">
                                        <input className="manually-enter-family-name-input" placeholder="Search Teacher" value={connection.displayName} onChange={(e) => searchDatabaseForTeacher(connection.connectionId, props.index, e.target.value)} />
                                    </div>
                                    {teacherNameSuggestions.length > 0 &&
                                        <div className="create-note-modal__search-bar-suggestions-wrapper">
                                            {teacherNameSuggestions.map((sugg) => (
                                                <h5 className="create-note-modal__search-bar-suggestions" key={sugg._id} onClick={() => chooseTheTeacher(connection.connectionId, sugg)}>{sugg.Name}</h5>
                                            ))}
                                        </div>
                                    }
                                </div>
                        }
                    </div>
                )}
                <textarea className='create-note-modal__text-area' value={props.createNote.details} onChange={(e) => writeNote(e.target.value)} placeholder='Type note here...' />
                {props.edit ? <div className='create-note-modal__submit-btn' onClick={() => props.sendTheEvent()}>Edit Event</div> : <div className='create-note-modal__submit-btn' onClick={() => props.sendTheEvent()}>Log Event</div>}
                {props.edit && <div className='create-note-modal__delete-btn' onClick={() => props.deleteTheEvent()}>Delete Event</div>}
                <div className='create-note-modal__cancel-btn' onClick={() => closeAttempt('create-note-wrapper')} >Cancel</div>
            </div>
        </div>
    )
}
export default CreateEvent;